module.exports = __webpack_public_path__ + "media/images/features/3/album/main-1-8603394eb67e0f076319fa134dd23f53.jpg";